module.exports = __webpack_public_path__ + "assets/0afc4801f6a7694ad22dbf3d3a0436fc.png";